export default __webpack_public_path__ + "static/media/009-mug.07bea3da.svg";